var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrutch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crutch_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crutch_svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "crutch_svg__cls-2",
    d: "M13.49 6.7l1.03 3.82-.37 6.36M9.63 7.74l1.02 3.81 3.5 5.33M14.15 16.88l1 3.86M14.22 21l1.93-.52M10.67 11.6l3.86-1M14.09 5.75A26.13 26.13 0 018.5 7.13a1.73 1.73 0 01-2-1.33 1.54 1.54 0 011.44-1.64A23.07 23.07 0 0013 3a1.62 1.62 0 012 .8 1.45 1.45 0 01-.91 1.95z"
  })));
}
export default SvgCrutch;


//////////////////
// WEBPACK FOOTER
// ./src/icons/crutch.svg
// module id = 460
// module chunks = 11